import { Box, Grid, Skeleton, styled } from '@mui/material';

export const Container = styled(Grid)(() => ({
  marginTop: '40px',
  border: '1px solid #D7D8DB',
  borderRadius: '8px',
  padding: '40px',
}));

export const SkeletonCardWrapper = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
}));

export const SkeletonLabel = styled(Skeleton)(() => ({
  borderRadius: '4px',
  width: 200,
  height: 20,
}));

export const SkeletonCard = styled(Skeleton)(() => ({
  borderRadius: '12px',
  width: 330,
  height: 112,
}));

export const ScrollableGrid = styled(Grid)(() => ({
  width: '96%',
  maxHeight: '400px',
  overflowY: 'scroll',
  borderRadius: '6px',
  '& > .MuiGrid-item': {
    width: '100%',
    display: 'block',
  },

  '&::-webkit-scrollbar': {
    width: '8px',
  },
  '&::-webkit-scrollbar-track': {
    background: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#8B8C8E',
    borderRadius: '4px',
  },
}));

export const ContentBox = styled(Box)(() => ({
  display: 'flex',
  flexWrap: 'wrap',
  columnGap: '43px',
  rowGap: '42px',
}));
